import { render, staticRenderFns } from "./sideBarItem.vue?vue&type=template&id=571e23ae&scoped=true"
import script from "./sideBarItem.vue?vue&type=script&lang=js"
export * from "./sideBarItem.vue?vue&type=script&lang=js"
import style0 from "./sideBarItem.vue?vue&type=style&index=0&id=571e23ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e23ae",
  null
  
)

export default component.exports